import { useEffect } from 'react';

export default function NoIndex() {
  useEffect(() => {
    const setMeta = (name: string) => {
      let meta = document.querySelector(`meta[name="${name}"]`) as HTMLMetaElement | null;
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('name', name);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', 'noindex,nofollow');
    };

    setMeta('robots');
    setMeta('googlebot');

    return () => {
      ['robots', 'googlebot'].forEach((name) => {
        const meta = document.querySelector(`meta[name="${name}"]`);
        if (meta) meta.remove();
      });
    };
  }, []);

  return null;
}
